<template>
  <div id="app">
    <commonHeader></commonHeader>
    <router-view />
    <commonFooter></commonFooter>
  </div>
</template>

<script>
import commonHeader from '@/components/commonHeader';
import commonFooter from '@/components/commonFooter';
export default {
  components: {
    commonHeader,
    commonFooter,
  },
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

@media screen and (max-width: 768px) {
  #app {
    overflow-x: hidden;
    overflow-y: visible;
    background-image: url('https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/m_bg.png');
    background-size: 100%;
    background-repeat: no-repeat;
  }
}
</style>
